import { Button, Stack, Typography } from "@mui/material"
import SearchIcon from "@mui/icons-material/Search";

const SearchBarButton = ({ label, onClickHandler }) => {
    return (
        <Button sx={{ padding: 0, flex: 1, display: "flex", justifyContent: "flex-start" }} variant="paper" onClick={(onClickHandler)}>
            <Stack sx={{
                minHeight: "60px",
                paddingInline: "30px",
                maxWidth: "100%"
            }} alignItems="center" direction="row" gap={1}>
                <SearchIcon sx={{ color: "complementary.main" }} />
                <Typography noWrap color="complementary.main" >{label}</Typography>
            </Stack>
        </Button>
    )
}

export default SearchBarButton;